import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  width: 100%;
  padding: 24px 24px 48px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  .SortableHelper {
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
  }

  .SortableHelper a {
    color: #212121;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const Title = styled.h2`
  margin: 0;
  color: #212121;
  font-size: 24px;
  line-height: 1.2;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const ListCard = styled.div`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eeeeee;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  padding: 8px 12px;
`;

export const SortableList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const SortableItem = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 10px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 15px;

  &:last-child {
    border-bottom: none;
  }
`;

export const SortableLink = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #212121;
  width: 100%;
`;

export const DragIconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #9e9e9e;
  cursor: grab;
  padding: 4px;
`;

export const ListHint = styled.p`
  margin: 0;
  color: #757575;
  font-size: 13px;
`;

export const FormCard = styled.div`
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eeeeee;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  padding: 16px;
`;

export const CreateButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #ed4e2a;
  color: #fff;
  padding: 10px 16px;
  border-radius: 10px;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0 6px 16px rgba(237, 78, 42, 0.3);
  transition: transform 160ms ease, box-shadow 160ms ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(237, 78, 42, 0.35);
  }
`;
